import { Box, LinearProgress, Typography, CircularProgress } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useEffect } from "react";

// import { uploadLocalFileParts } from "../store/actions/filesUpload";
import { checkUploadingStatus } from "../store/actions/filesUpload";
import type { RootState } from "../store/state/rootReducer";
import type { AppDispatch } from "../store/state/rootStore";

export const UploadingFilesProgress = () => {
  const { current, total, stories, filesCompleted, uploadingFiles } = useSelector(
    (state: RootState) => state.uploadFiles
  );
  const dispatch = useDispatch<AppDispatch>();
  const uploadingFromCloud = JSON.parse(localStorage.getItem("uploadingFiles"));
  const hasLocalUpload = stories.some((story) => story.type === "local");
  const percent = ((current + filesCompleted) / total) * 100;

  const handleTabClose = (event) => {
    event.preventDefault();
    event.returnValue = "You have uploads in progress. Are you sure you want to exit?";
    return event.returnValue;
  };

  useEffect(() => {
    if (uploadingFromCloud) {
      const uploadInterval = setInterval(() => {
        dispatch(checkUploadingStatus());
      }, 5000);

      return () => {
        clearInterval(uploadInterval);
      };
    }
    return undefined;
  }, [uploadingFiles]);

  useEffect(() => {
    if (uploadingFiles && hasLocalUpload) {
      window.addEventListener("beforeunload", handleTabClose);
    }
    if (!uploadingFiles || !hasLocalUpload) {
      window.removeEventListener("beforeunload", handleTabClose);
    }
    return () => {
      window.removeEventListener("beforeunload", handleTabClose);
    };
  }, [uploadingFiles, hasLocalUpload]);

  return (
    <Box
      width={"165px"}
      display={"flex"}
      flexDirection={"column"}
      padding={"12px"}
      justifyContent={"center"}
      sx={{ borderRadius: "4px", border: "1px solid #75808A", background: "#FFF" }}
    >
      {stories.length ? (
        <>
          <Box display={"flex"} gap={"4px"} alignItems={"center"}>
            <CloudUploadIcon sx={{ fontSize: "16px !important", color: "#75808A" }} />
            <Typography sx={{ fontSize: "12px", fontWeight: 700, lineHeight: "16px" }}>Uploading files</Typography>
          </Box>
          <Typography sx={{ fontSize: "12px", fontWeight: 700, lineHeight: "16px" }}>
            {filesCompleted} of {total} files uploaded
          </Typography>
          <Box sx={{ width: "100%", marginTop: "10px" }}>
            <LinearProgress
              variant="determinate"
              sx={{ backgroundColor: "#464C534D", "& span": { backgroundColor: "#75808A" } }}
              value={percent}
            />
          </Box>
        </>
      ) : (
        <Box display={"flex"} alignItems={"center"} justifyContent={"center"}>
          <CircularProgress size="2rem" />
        </Box>
      )}
    </Box>
  );
};
